import { normalizeClientFeedCategoryOrder, type ClientFeedTab } from '@/entities/client-feed-categories';
import { repairStoredOrder } from '@/entities/client-feed-categories-order.storage';
import { createEvent, createStore } from 'effector';

const STORAGE_KEY = 'crave:client-feed-category-order';

function readStoredOrder(): ClientFeedTab[] {
	const raw = localStorage.getItem(STORAGE_KEY);
	const { order, needsWrite } = repairStoredOrder(raw);
	if (needsWrite) writeStoredOrder(order);
	return order;
}

function writeStoredOrder(order: ClientFeedTab[]) {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(order));
	} catch {
		// ignore quota / private mode
	}
}

export const $setClientFeedCategoryOrder = createEvent<ClientFeedTab[]>();
export const $reorderClientFeedCategory = createEvent<{ activeId: ClientFeedTab; overId: ClientFeedTab }>();

export const $clientFeedCategoryOrder = createStore<ClientFeedTab[]>(readStoredOrder())
	.on($setClientFeedCategoryOrder, (_, order) => normalizeClientFeedCategoryOrder(order))
	.on($reorderClientFeedCategory, (order, { activeId, overId }) => {
		const from = order.indexOf(activeId);
		const to = order.indexOf(overId);
		if (from === -1 || to === -1 || from === to) return order;

		const next = [...order];
		const [moved] = next.splice(from, 1);
		next.splice(to, 0, moved);
		return next;
	});

$clientFeedCategoryOrder.watch(order => {
	writeStoredOrder(order);
});
